<template>
    <div class="navbar">
        <div class="navbar_top">
            <div class="inner">
                <div class="left">
                    <img src="~@/assets/images/logo3.png" alt="logo">
                    <p>技能河南·人人持证</p>
                </div>
                <div class="right">
                    <div class="searchBox">
                        <input v-model="search" type="text" placeholder="搜索课程" @keyup.enter="handleSearch">
                        <i class="icon" @click="handleSearch"></i>
                    </div>
                    <div class="login" v-if="!$store.getters.userId">
                        <span @click="handleLogin">登录</span>
                    </div>
                    <el-popover
                        v-else
                        placement="bottom"
                        width="50"
                        trigger="click">
                        <el-tooltip slot="reference" :disabled="($store.getters.name.length>=6)?false:true" :content="$store.getters.name" placement="left">
                            <div class="login_success">
                                <el-image
                                    style="width: 30px; height: 30px;border-radius:6px;overflow:hidden;"
                                    :src="$store.getters.avatar||avatardefauter"
                                    fit="scale-down"></el-image>
                                <div class="user_name">{{$store.getters.name}}</div>
                            </div>
                        </el-tooltip>
                        <div class="logoutclick" @click="handleLogout">
                            <img style="width:20px" src="~@/assets/images/logout.png" alt="">
                            <span>退出登录</span>
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>
        <sticky :zIndex="1000" className="sticky_navbar">
            <div class="inner">
                <div class="nav_box">
                    <router-link to="/home">首页</router-link>
                    <router-link to="/standard">职业技能标准</router-link>
                    <router-link to="/notice">政策公告</router-link>
                    <router-link to="/learning-center">学习中心</router-link>
                    <router-link to="/app-synopsis">APP简介</router-link>
                    <router-link to="/about">关于我们</router-link>
                </div>
            </div>
        </sticky>
    </div>
</template>
<script>
import Sticky from "@/components/Sticky"
import bus from '@/utils/bus'
export default {
    name:'NavBar',
    components:{
        Sticky
    },
    data(){
        return {
            search:'',
            avatardefauter:require('@/assets/images/avatardefauter.png'),
            userName:'流年啊！'
        }
    },
    mounted(){
        console.log(this.$route)
    },
    methods:{
        handleLogin(){
            var that = this
            this.$login({
                loginSuccess(){
                    that.$router.push({
                        path: '/redirect' + that.$route.fullPath
                    })
                },
            })
        },
        handleLogout(){
            this.$store.dispatch('user/logout').then(() => {
                this.$message.success('退出成功')
                console.log(this.$route.fullPath)
                if(this.$route.fullPath!=='/home'){
                    this.$router.push({path:'/'})
                }
            })
        },
        handleSearch(){
            if(this.$route.path !== '/search-result'){
                this.$router.push({name:'SearchResult',params: {id:this.search}})
            }else{
                bus.$emit('setSearch',this.search)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.navbar{
    background: #fff;
    .navbar_top{
        padding: 30px 0 12px;
        .inner{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .left{
            display: flex;
            align-items: center;
            font-size: 30px;
            font-weight: 800;
            color: #333333;
            p{
                margin-left: 21px;
            }
        }
        .right{
            display: flex;
            align-items: center;
            .login{
                font-size: 24px;
                font-weight: bold;
                color: #333333;
                line-height: 1;
                cursor: pointer;
                transition: all .3s;
                &:hover{
                    color: #3964E6;
                }
                width: 194px;
                text-align: right;
            }
            .login_success{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                position: relative;
                width: 194px;
                cursor: pointer;
                .user_name{
                    font-size:20px;
                    font-weight: bold;
                    max-width: 132px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    margin-left: 10px;
                }
            }
        }
        .searchBox{
            width: 500px;
            height: 40px;
            box-sizing: border-box;
            padding: 6px 15px;
            border: 2px solid #3964E6;
            border-radius: 40px;
            position: relative;
            display: flex;
            align-content: center;
            padding-right: 90px;
            overflow: hidden;
            input{
                height: 100%;
                width: 100%;
                color: #3964E6;
                font-size: 18px;
                font-weight: bold
            }
            input::-webkit-input-placeholder{
                color:#3964e6b8;
            }
            input:-moz-placeholder{
                color:#3964e6b8;
            }
            input::-moz-placeholder{
                color:#3964e6b8;
            }
            input:-ms-input-placeholder{
                color:#3964e6b8;
            }
            .icon{
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translateY(-50%);
                height: 40px;
                width: 90px;
                background-color: #3964E6;
                background-image: url('~@/assets/images/search.png');
                background-repeat: no-repeat;
                background-position: center center;
                cursor: pointer;
            }
        }
    }
    .nav_box{
        display: flex;
        height: 100%;
        // justify-content: center;
        align-items: center;
        font-size: 20px;
        margin-left: -15px;
        padding: 20px 0;
        a{
            padding: 0 15px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            transition: all .3s;
            &:hover{
                color: #3964E6;
            }
        }
        .router-link-active{
            color: #3964E6;
        }
    }
    .sticky_navbar_list{
        display: flex;
        // justify-content: space-between;
        align-items: center;
        
        .img_box{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            line-height: 1;
            font-weight: bold;
            font-family: PingFang SC;
            img{
                margin-right: 9px;
            }
        }
        
        
    }
    ::v-deep .sticky_navbar{
        background: #fff;
    }
    
}
</style>
<style>
.logoutclick{
    display: flex;
    font-size: 16px;
    font-weight: bold;
    color: #999999;
    cursor: pointer;
    line-height: 1;
    justify-content: center;
    align-items: center;
}
.logoutclick img{
    margin-right: 5px;
}
</style>